<template>
  <div>
    <CRow>
      <CCol xs="6" sm="6" md="6" lg="6" xl="6" class="mb-2">
        <button
          type="button"
          class="btn btn-sm btn-outline-main bg-purple color-white"
          @click="returnHome"
        >
          <i class="fas fa-home-lg-alt"></i>&nbsp;&nbsp;Inicio
        </button>
      </CCol>
      <CCol xs="6" sm="6" md="6" lg="6" xl="6" class="mb-2 text-right">
        <button
          @click="mtdOpenModalExpense"
          class="btn btn-sm btn-info btn-md mx-1"
        >
          <b><i class="fab fa-creative-commons-nc"></i>&nbsp; Egresos</b>
        </button>
        <button
          @click="mtdOpenModalRetirementDeposit"
          class="btn btn-sm btn-info btn-md mx-1"
        >
          <b><i class="far fa-money-bill-alt"></i>&nbsp; Depósito/Retiro</b>
        </button>
        <button @click="mtdCloseBead" class="btn btn-sm btn-info btn-md">
          <b><i class="fas fa-cash-register"></i>&nbsp;Cerrar Caja</b>
        </button>
      </CCol>
    </CRow>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="2" xl="2">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Total Efectivo</span>
          </CCardHeader>
          <CCardBody class="border">
            <div>Apertura: {{ this.bead.initial }}</div>
          </CCardBody>
          <CCardBody
            class="border"
            style="cursor: pointer"
            @click="mtdOpenModalIncome('ingreso')"
          >
            <div>Ingresos: {{ this.bead.income }}</div>
          </CCardBody>
          <CCardBody
            class="border"
            style="cursor: pointer"
            @click="mtdOpenModalIncome('egreso')"
          >
            <div>Egresos: {{ this.bead.expense }}</div>
          </CCardBody>
          <CCardBody
            class="border"
            style="cursor: pointer"
            @click="mtdOpenModalMovement('retiro')"
          >
            <div>Retiros: {{ this.sumaRetiro() }}</div>
          </CCardBody>
          <CCardBody
            class="border"
            style="cursor: pointer"
            @click="mtdOpenModalMovement('deposito')"
          >
            <div>Depósito: {{ this.sumaDeposito() }}</div>
          </CCardBody>
          <CCardBody class="border">
            <div>
              <b>Total: {{ this.bead.final }} </b>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="2" xl="2">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Otros Ingresos</span>
          </CCardHeader>
          <template v-for="(method, index) in data_methodpayment">
            <CCardBody
              v-if="method.name != 'EFECTIVO'"
              :key="index"
              class="border"
              style="cursor: pointer"
              @click="handleMethodPayment(method.name)"
            >
              <div>{{ method.name }}: {{ getMethodValue(method.name) }}</div>
            </CCardBody>
          </template>
        </CCard>
        <div class="d-flex justify-content-end"></div>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="2" xl="2">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Otros Egresos</span>
          </CCardHeader>
          <template v-if="castExpense.length > 0">
            <template v-for="(item, index) in castExpense">
              <CCardBody
                v-if="item.name != 'EFECTIVO'"
                :key="index"
                class="border"
                style="cursor: pointer"
                @click="handleMethodPaymentEgreso(item.name)"
              >
                <div>
                  {{ item.name }}: {{ parseFloat(item.amount).toFixed(2) }}
                </div>
              </CCardBody>
            </template>
          </template>
          <template v-else>
            <CCardBody class="border" style="cursor: pointer">
              <div>NO TIENE OTROS EGRESOS</div>
            </CCardBody>
          </template>
        </CCard>
        <div class="d-flex justify-content-end"></div>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <CCard>
          <CCardHeader class="bg-gris text-center font-weight-bold">
            <span>Arqueo de cierre de caja</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div
                class="col-md-12 col-lg-6 col-sm-12 col-xs-12 mt-0 text-center"
              >
                <label class="form-label text-center"
                  ><strong>Billetes</strong></label
                >
                <div v-for="(item, index) in billetes" :key="index" class="">
                  <CInput
                    :append="item.total == 0 ? '0.00' : item.total"
                    @keyup="mtdContarBilletes"
                    @keydown="filterKey"
                    placeholder="0"
                    v-model="item.cantidad"
                  >
                    <template #prepend-content>{{ item.label }}</template>
                  </CInput>
                </div>
              </div>
              <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 text-center">
                <label class="form-label text-center"
                  ><strong>Monedas</strong></label
                >
                <div v-for="(item, index) in monedas" :key="index" class="">
                  <CInput
                    :append="item.total == 0 ? '0.00' : item.total"
                    @keyup="mtdContarBilletes"
                    @keydown="filterKey"
                    placeholder="0"
                    v-model="item.cantidad"
                  >
                    <template #prepend-content>{{ item.label }}</template>
                  </CInput>
                </div>
              </div>
            </CRow>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4">
                <CInput
                  type="text"
                  disabled
                  v-model="this.bead.final"
                  label="Efectivo Sistema"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4">
                <CInput
                  type="text"
                  disabled
                  v-model="finalCash"
                  label="Efectivo Caja"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4">
                <CInput
                  type="text"
                  disabled
                  v-model="cpDiferencia"
                  :label="labelDiferencia"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="container mx-auto p-4">
      <cModalIncome
        :title="modalIncome.title"
        :boo_modal="modalIncome.modal_form"
        :incomes="modalIncome.income"
        :incomes_reserva="modalIncome.income_reserva"
        :type="modalIncome.type"
        @closeModalIncome="closeModalIncome"
      />
      <cModalRetirementDeposit
        :title="modalRetirementDeposit.title"
        :boo_modal="modalRetirementDeposit.modal_form"
        :bead_id="modalRetirementDeposit.bead_id"
        :bead_final="modalRetirementDeposit.bead_final"
        @closeModalRetirementDeposit="closeModalRetirementDeposit"
        @mtdRefreshData="mtdRefreshData"
        @resetData="resetData"
      />
      <cModalMovement
        :title="modalMovement.title"
        :boo_modal="modalMovement.modal_form"
        :movements="modalMovement.movement"
        :type="modalMovement.type"
        @closeModalMovement="closeModalMovement"
      />
      <cModalOtrosIngresos
        :title="modalData.title"
        :boo_modal="modalData.modal_form"
        :data="modalData.data"
        :data_reserva="modalData.data_reserva"
        @closeModal="closeModal"
      />
      <cModalOtrosEgresos
        :title="modalDataEgresos.title"
        :boo_modal="modalDataEgresos.modal_form"
        :data="modalDataEgresos.data"
        :data_reserva="modalDataEgresos.data_reserva"
        @closeModal="closeModalEgresos"
      />
      <!-- modal expense -->
      <CModalExpense
        :title="modalExpense.title"
        :boo_modal="modalExpense.modal_form"
        :types="modalExpense.type"
        :method="modalExpense.method"
        @mtdRefreshData="mtdRefreshData"
        @closeModalExpense="closeModalExpense"
        @commitModalExpense="commitModalExpense"
        @resetData="resetData"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import cModalIncome from "../modals/cModalIncome.vue";
import cModalRetirementDeposit from "../modals/cModalRetiremetDeposit.vue";
import cModalMovement from "../modals/cModalMovement.vue";
import cModalOtrosIngresos from "../modals/cModalOtrosIngresos.vue";
import cModalOtrosEgresos from "../modals/cModalOtrosEgresos.vue";
import CModalExpense from "../modals/cModalExpense.vue";

export default {
  name: "close-bead",
  components: {
    cModalIncome,
    cModalRetirementDeposit,
    cModalMovement,
    cModalOtrosIngresos,
    CModalExpense,
    cModalOtrosEgresos,
  },
  data() {
    return {
      prefix: "beads",
      // Nuevos
      data_efectivo_egreso: [],
      data_transferencia_egreso: [],
      data_tarjeta_egreso: [],
      data_deposito_egreso: [],
      data_yape_egreso: [],
      data_plin_egreso: [],
      // fin nuevos
      data_methodpayment: [],
      data_charge: [],
      data_ingresos_reserva: [],
      data_transferencia_reserva: [],
      data_tarjeta_reserva: [],
      data_deposito_reserva: [],
      data_yape_reserva: [],
      data_plin_reserva: [],
      data_ingresos: [],
      data_transferencia: [],
      data_tarjeta: [],
      data_deposito: [],
      data_yape: [],
      data_plin: [],
      data_egresos: [],
      all_data_egresos: [],
      verificBead: false,
      bead: {
        id: "",
        box_id: "",
        user_id: this.$store.getters.get__user_id,
        campu_id: this.$store.getters.get_campu.id,
        company_id: this.$store.getters.get_company.id,
        initial: "",
        final: "",
        expense: "",
        income: "",
        card: "",
        turned: "",
        transfer: "",
        retirement: "",
        status_open: "",
        status_close: "",
        deposit: "",
        authorize: "",
        state: "",
      },
      process: {
        box_id: "",
        bead_id: "",
        otrosEgresos: [],
        otroIngresos: [
          {
            label: "Transferencia",
            total: 0,
          },
          {
            label: "Tarjeta",
            total: 0,
          },
          {
            label: "Deposito",
            total: 0,
          },
          {
            label: "Yape",
            total: 0,
          },
          {
            label: "Plin",
            total: 0,
          },
        ],
        observation: "",
        totIncome: 0,
        totExpense: 0,
        retirement: 0,
        deposit_efectivo: 0,
        initial: 0,
        final: 0,
      },
      modalIncome: {
        title: "Ingresos",
        modal_form: false,
        income: [],
        income_reserva: [],
        type: "",
      },
      modalMovement: {
        title: "Retiro",
        modal_form: false,
        movement: [],
        type: "",
      },
      modalRetirementDeposit: {
        title: "",
        modal_form: false,
        bead_id: "",
        bead_final: 0,
      },
      modalData: {
        title: "",
        modal_form: false,
        data: [],
        data_reserva: [],
      },
      modalDataEgresos: {
        title: "",
        modal_form: false,
        data: [],
        data_reserva: [],
      },
      incomes: [],
      movement: [],
      movement_retiros: [],
      movement_depositos: [],
      /** expense */
      expenses: [],
      types: [],
      modalExpense: {
        title: "Expense",
        modal_form: false,
        type: [],
        method: [],
      },
      /** arqueo */
      billetes: [
        {
          label: "200.00",
          total: 0,
          key: "dosCientos",
          value: 200,
          cantidad: "",
        },
        {
          label: "100.00",
          total: 0,
          key: "unCiento",
          value: 100,
          cantidad: "",
        },
        {
          label: "50.00",
          total: 0,
          key: "cincuenta",
          value: 50,
          cantidad: "",
        },
        {
          label: "20.00",
          total: 0,
          key: "veinte",
          value: 20,
          cantidad: "",
        },
        {
          label: "10.00",
          total: 0,
          key: "diez",
          value: 10,
          cantidad: "",
        },
      ],
      monedas: [
        {
          label: "5.00",
          total: 0,
          key: "cinco",
          value: 5,
          cantidad: "",
        },
        {
          label: "2.00",
          total: 0,
          key: "dos",
          value: 2,
          cantidad: "",
        },
        {
          label: "1.00",
          total: 0,
          key: "uno",
          value: 1,
          cantidad: "",
        },
        {
          label: "0.50",
          total: 0,
          key: "cincuentaCentimos",
          value: 0.5,
          cantidad: "",
        },
        {
          label: "0.20",
          total: 0,
          key: "veinteCentimos",
          value: 0.2,
          cantidad: "",
        },
        {
          label: "0.10",
          total: 0,
          key: "diezCentimos",
          value: 0.1,
          cantidad: "",
        },
      ],
      finalCash: 0,
      labelDiferencia: "Falta",
      diferencia: 0,
    };
  },
  watch: {
    "bead.id": function (newId) {
      if (newId) {
        this.mtdReportBeads();
        this.showChargue();
        this.showMovement();
      }
    },
  },
  computed: {
    castExpense() {
      let cast = [];
      this.expenses.forEach((element) => {
        let temp = cast.filter((el) => el.name == element.method_payment.name);
        if (temp.length == 0) {
          cast.push({
            method_payment_id: element.method_payment_id,
            name: element.method_payment.name,
            amount: parseFloat(element.amount).toFixed(2),
          });
        } else {
          cast.forEach((el) => {
            if (el.name == element.method_payment.name) {
              el.amount = parseFloat(el.amount) + parseFloat(element.amount);
            }
          });
        }
      });

      this.process.otrosEgresos = cast;
      return cast;
    },
    cpDiferencia() {
      let dif = parseFloat(this.bead.final) - parseFloat(this.finalCash);
      if (dif > 0) {
        this.diferencia = parseFloat(dif).toFixed(2);
        this.labelDiferencia = "Falta";
      } else if (dif < 0) {
        this.diferencia = parseFloat(dif * -1).toFixed(2);
        this.labelDiferencia = "Sobra";
      } else {
        this.diferencia = parseFloat(dif).toFixed(2);
        this.labelDiferencia = "Exacto";
      }
      return this.diferencia;
    },
  },
  created() {
    this.mtdGetData();
    // this.showBead();
    // this.showMethodPayment();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome: function () {
      this.$emit("setView", "home");
    },
    mtdRefreshData() {
      this.mtdGetData();
      this.mtdReportBeads();
      this.showMovement();
      this.showChargue();
    },
    mtdGetData: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/index/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data.bead ? true : false;
            this.bead = this.verificBead == true ? response.data.bead : {};
            this.data_methodpayment = [];
            response.data.methodPayment.forEach((arr) => {
              this.data_methodpayment.push(arr);
            });
            this.types = [];
            response.data.type.forEach((element) => {
              this.types.push({
                label: element.name,
                value: element.id,
              });
            });
            this.expenses = response.data.expenses;
          }
        })
        .catch((errors) => {});
    },
    mtdReportBeads: function () {
      this.get({
        url:
          this.$store.getters.get__url + "/beads/reportClose/" + this.bead.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.incomes = response.data;
            this.process.initial = this.bead.initial;
            this.process.totIncome = this.bead.income;
            this.process.final = this.bead.final;
            this.process.bead_id = this.bead.id;
            this.process.box_id = this.bead.box_id;
            this.process.deposit_efectivo = this.bead.deposit_cash;
            this.process.retirement = this.bead.retirement;
            this.process.totExpense = this.expenses;
            this.completedJson();
          }
        })
        .catch((errors) => {});
    },
    completedJson: function () {
      const totals = {
        EFECTIVO: 0,
        DEPOSITO: 0,
        TARJETA: 0,
        YAPE: 0,
        TRANSFERENCIA: 0,
        PLIN: 0,
      };

      this.incomes.forEach((element) => {
        if (totals.hasOwnProperty(element.method)) {
          totals[element.method] += parseFloat(element.amount);
        }
      });
      //completar el json
      this.process.otroIngresos.forEach((ele) => {
        if (ele.label == "Transferencia") {
          ele.total = parseFloat(totals["TRANSFERENCIA"]);
        }
        if (ele.label == "Tarjeta") {
          ele.total = parseFloat(totals["TARJETA"]);
        }
        if (ele.label == "Deposito") {
          ele.total = parseFloat(totals["DEPOSITO"]);
        }
        if (ele.label == "Yape") {
          ele.total = parseFloat(totals["YAPE"]);
        }
        if (ele.label == "Plin") {
          ele.total = parseFloat(totals["PLIN"]);
        }
      });
    },
    mtdCloseBead() {
      if (this.finalCash > 0) {
        this.process.billetes = this.billetes;
        this.process.monedas = this.monedas;
        this.post({
          url: this.$store.getters.get__url + "/beads/close",
          token: this.$store.getters.get__token,
          params: {
            bead: this.bead,
            process: this.process,
          },
        })
          .then((response) => {
            if (response.statusCode == 200) {
              Swal.fire({
                title: "Caja Cerrada Correctamente",
                icon: "success",
              });
              //volver
              this.exportPdf();
              this.returnHome();
            }
          })
          .catch((errors) => {
            Swal.fire({
              title: errors,
              icon: "danger",
            });
          });
      } else {
        Swal.fire({
          title: "Digite arqueo",
          icon: "warning",
        });
      }
    },
    handleMethodPayment(methodName) {
      switch (methodName) {
        case "TRANSFERENCIA":
          this.mtdOpenModal("transfer");
          break;
        case "TARJETA":
          this.mtdOpenModal("card");

          break;
        case "DEPOSITO":
          this.mtdOpenModal("deposit");
          break;
        case "YAPE":
          this.mtdOpenModal("yape");
          break;
        case "PLIN":
          this.mtdOpenModal("plin");
          break;
        default:
          console.warn("Método de pago no soportado:", methodName);
      }
    },
    handleMethodPaymentEgreso(methodName) {
      switch (methodName) {
        case "TRANSFERENCIA":
          this.mtdOpenModalEgreso("transfer");
          break;
        case "TARJETA":
          this.mtdOpenModalEgreso("card");

          break;
        case "DEPOSITO":
          this.mtdOpenModalEgreso("deposit");
          break;
        case "YAPE":
          this.mtdOpenModalEgreso("yape");
          break;
        case "PLIN":
          this.mtdOpenModalEgreso("plin");
          break;
        default:
          console.warn("Método de pago no soportado:", methodName);
      }
    },
    getMethodValue(methodName) {
      switch (methodName) {
        case "TRANSFERENCIA":
          return this.bead.transfer;
        case "TARJETA":
          return this.bead.card;
        case "DEPOSITO":
          return this.bead.deposit;
        case "YAPE":
          return this.sumaYape();
        case "PLIN":
          return this.sumaPlin();
        default:
          return null;
      }
    },
    mtdOpenModal(type) {
      let title, data, data_reserva;
      switch (type) {
        case "transfer":
          title = "Transferencia";
          data = this.data_transferencia;
          data_reserva = this.data_transferencia_reserva;
          break;
        case "card":
          title = "Tarjeta";
          data = this.data_tarjeta;
          data_reserva = this.data_tarjeta_reserva;
          break;
        case "deposit":
          title = "Deposito";
          data = this.data_deposito;
          data_reserva = this.data_deposito_reserva;
          break;
        case "yape":
          title = "Yape";
          data = this.data_yape;
          data_reserva = this.data_yape_reserva;
          break;
        case "plin":
          title = "Plin";
          data = this.data_plin;
          data_reserva = this.data_plin_reserva;
          break;
        default:
          return;
      }

      this.modalData = {
        title: title,
        modal_form: true,
        data: data,
        data_reserva: data_reserva,
      };
    },
    mtdOpenModalEgreso(type) {
      let title, data, data_reserva;
      switch (type) {
        case "transfer":
          title = "Transferencia";
          data = this.data_transferencia_egreso;
          break;
        case "card":
          title = "Tarjeta";
          data = this.data_tarjeta_egreso;
          break;
        case "deposit":
          title = "Deposito";
          data = this.data_deposito_egreso;
          break;
        case "yape":
          title = "Yape";
          data = this.data_yape_egreso;
          break;
        case "plin":
          title = "Plin";
          data = this.data_plin_egreso;
          break;
        default:
          return;
      }

      this.modalDataEgresos = {
        title: title,
        modal_form: true,
        data: data,
        data_reserva: data_reserva,
      };
    },
    closeModal() {
      this.modalData.modal_form = false;
    },
    closeModalEgresos() {
      this.modalDataEgresos.modal_form = false;
    },
    mtdOpenModalIncome(type) {
      this.modalIncome = {
        title: type == "ingreso" ? "Ingresos" : "Egresos",
        modal_form: true,
        income: type == "ingreso" ? this.data_ingresos : this.data_egresos,
        income_reserva: type == "ingreso" ? this.data_ingresos_reserva : [],
        type: type,
      };
    },
    closeModalIncome() {
      this.modalIncome.modal_form = false;
    },
    mtdOpenModalMovement(type) {
      this.modalMovement = {
        title: type == "retiro" ? "Retiro" : "Depósito",
        modal_form: true,
        movement:
          type == "retiro" ? this.movement_retiros : this.movement_depositos,
        type: type,
      };
    },
    closeModalMovement() {
      this.modalMovement.modal_form = false;
    },
    mtdOpenModalRetirementDeposit() {
      this.modalRetirementDeposit = {
        title: "Registrar Retiros o Depósitos",
        modal_form: true,
        bead_id: this.bead.id ? this.bead.id : "",
        bead_final: this.bead.final ? this.bead.final : 0.0,
      };
    },
    resetData() {
      this.movement = [];
      this.movement_depositos = [];
      this.movement_retiros = [];
      this.data_efectivo_egreso = [];
      this.data_transferencia_egreso = [];
      this.data_tarjeta_egreso = [];
      this.data_deposito_egreso = [];
      this.data_yape_egreso = [];
      this.data_plin_egreso = [];
      this.data_methodpayment = [];
      this.data_charge = [];
      this.data_ingresos_reserva = [];
      this.data_transferencia_reserva = [];
      this.data_tarjeta_reserva = [];
      this.data_deposito_reserva = [];
      this.data_yape_reserva = [];
      this.data_plin_reserva = [];
      this.data_ingresos = [];
      this.data_transferencia = [];
      this.data_tarjeta = [];
      this.data_deposito = [];
      this.data_yape = [];
      this.data_plin = [];
      this.data_egresos = [];
      this.all_data_egresos = [];
      this.incomes = [];
      this.movement = [];
      this.movement_retiros = [];
      this.movement_depositos = [];
      this.expenses = [];
      this.types = [];
    },
    closeModalRetirementDeposit() {
      this.modalRetirementDeposit = {
        modal_form: false,
      };
    },
    showMovement() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/filterMovement/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.bead.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.movement = response.data;
            this.movement.forEach((item) => {
              if (item.type == 1) {
                this.movement_depositos.push(item);
              } else if (item.type == 2) {
                this.movement_retiros.push(item);
              }
            });
          }
        })
        .catch((errors) => {});
    },
    showChargue() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/filterChargue/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.bead.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.data_charge = response.data.charge;

            this.data_egresos = response.data.expenses.filter(
              (expense) => expense.method_payment.name === "EFECTIVO"
            );
            this.all_data_egresos = response.data.expenses;
            this.filterIncomes();
          }
        })
        .catch((errors) => {});
    },
    filterIncomes() {
      this.data_charge.forEach((element) => {
        if (element.sale.type == 1) {
          if (element.method == "EFECTIVO") {
            this.data_ingresos_reserva.push(element);
          }
          if (element.method == "TRANSFERENCIA") {
            this.data_transferencia_reserva.push(element);
          }
          if (element.method == "TARJETA") {
            this.data_tarjeta_reserva.push(element);
          }
          if (element.method == "DEPOSITO") {
            this.data_deposito_reserva.push(element);
          }
          if (element.method == "YAPE") {
            this.data_yape_reserva.push(element);
          }
          if (element.method == "PLIN") {
            this.data_plin_reserva.push(element);
          }
        }

        if (element.sale.type == 0) {
          if (element.method == "EFECTIVO") {
            this.data_ingresos.push(element);
          }
          if (element.method == "TRANSFERENCIA") {
            this.data_transferencia.push(element);
          }
          if (element.method == "TARJETA") {
            this.data_tarjeta.push(element);
          }
          if (element.method == "DEPOSITO") {
            this.data_deposito.push(element);
          }
          if (element.method == "YAPE") {
            this.data_yape.push(element);
          }
          if (element.method == "PLIN") {
            this.data_plin.push(element);
          }
        }
      });

      this.all_data_egresos.forEach((newElement) => {
        if (newElement.method_payment.name == "EFECTIVO") {
          this.data_efectivo_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "TRANSFERENCIA") {
          this.data_transferencia_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "TARJETA") {
          this.data_tarjeta_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "DEPOSITO") {
          this.data_deposito_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "YAPE") {
          this.data_yape_egreso.push(newElement);
        }
        if (newElement.method_payment.name == "PLIN") {
          this.data_plin_egreso.push(newElement);
        }
      });
    },

    sumaYape() {
      const allYapeData = [...this.data_yape, ...this.data_yape_reserva];
      const suma = allYapeData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaPlin() {
      const allPlinData = [...this.data_plin, ...this.data_plin_reserva];
      const suma = allPlinData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaRetiro() {
      const suma = this.movement_retiros.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaDeposito() {
      const suma = this.movement_depositos.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    exportPdf: function () {
      window.open(
        this.$store.getters.get__url +
          "/beads/viewpdfreportegeneral/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.bead.id,
        "_blank"
      );
    },
    /** expenses */
    mtdOpenModalExpense: function () {
      this.modalExpense = {
        title: "Registrar Egreso",
        modal_form: true,
        type: this.types,
        method: this.data_methodpayment,
      };
    },
    closeModalExpense: function () {
      this.modalExpense = {
        title: "Registrar Egreso",
        modal_form: false,
        type: this.types,
        method: this.data_methodpayment,
      };
    },
    commitModalExpense: function (expense) {
      this.post({
        url:
          this.$store.getters.get__url +
          "/beads/expense/store/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
        params: {
          expense: expense,
          bead: this.bead,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.closeModalExpense();
            this.mtdGetData();
            Swal.fire({
              title: "Egreso registrado correctamente",
              icon: "success",
            });
          } else {
            Swal.fire({
              title: "Error al registrar",
              icon: "error",
            });
          }
        })
        .catch((errors) => {});
    },
    /** arqueo */
    mtdContarBilletes() {
      let total = 0;
      this.billetes.forEach((element) => {
        let can = 0;
        if (!element.cantidad) {
          can = 0;
        }
        can =
          element.cantidad != "" && element.cantidad != null
            ? parseFloat(element.cantidad).toFixed(2)
            : 0;
        let tot = parseFloat(element.value).toFixed(2);
        element.total = tot == NaN ? 0 : parseFloat(can * tot).toFixed(2);
        total += parseFloat(element.total);
      });

      this.monedas.forEach((element) => {
        let can = 0;
        if (!element.cantidad) {
          can = 0;
        }
        can =
          element.cantidad != "" && element.cantidad != null
            ? parseFloat(element.cantidad).toFixed(2)
            : 0;
        let tot = parseFloat(element.value).toFixed(2);
        element.total = tot == NaN ? 0 : parseFloat(can * tot).toFixed(2);
        total += parseFloat(element.total);
      });
      this.finalCash = total;
    },
    filterKey: function (e) {
      let b = false;
      b = /^[0-9]+$/.test(e.key);
      if (b == false && e.key != "Backspace") {
        e.preventDefault();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-gris {
  background-color: #dee2e6;
}

.bg-purple {
  background-color: #926cdc;
}

.color-white {
  color: white;
}
</style>